import { useState } from 'react';
import AssignmentCardView from './AssignmentCardView';
import AssignmentCardEdit from './AssignmentCardEdit';
import { useSectionChiefResolver } from './useSectionChiefResolver';
import { WorkGroupResourceNeed, ProposedStatusOption, SimplifiedWorkAssignment } from './AssignmentList';
import { PlannedResource } from 'components/IAP/hooks/assignmentListHooks';

export type AssignmentListRow = {
  id?: string;
  walaId: string | null;
  workGroupId: string;
  workGroup: string;
  branch: string;
  division: string;
  walaGroup: string;
  stagingArea: string;
  proposedStatus: ProposedStatusOption;
  actualStatus: string | null;
  sectionChief?: string;
  branchDirector?: string;
  divisionGroupSupervisor?: string;
  workAssignments: SimplifiedWorkAssignment[];
  workGroupResourceNeeds: WorkGroupResourceNeed[];
  plannedResources: PlannedResource[] | null;
  medicalCommunication?: string;
  evacuationCommunication?: string;
  otherCommunication?: string;
  specialInstructions?: string;
};

interface AssignmentCardProps {
  columns: string[];
  item: AssignmentListRow;
  periodNumber: number;
}

const AssignmentContainer: React.FC<AssignmentCardProps> = ({ columns, item, periodNumber }) => {
  const [expanded, setExpanded] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  
  const { isCurrentUserSectionChief: isCurrentUserReviewer, sectionChief } = useSectionChiefResolver(item.workGroupId);

  return (
    <div className={'filter-card-border'}>
      {isEditing ? (
        <AssignmentCardEdit
          sectionChief={sectionChief}
          row={item}
          setIsEditing={setIsEditing}
          columnNumber={columns.length}
          periodNumber={periodNumber}
        />
      ) : (
        <AssignmentCardView
          sectionChief={sectionChief}
          columns={columns}
          item={item}
          expanded={expanded}
          setExpanded={setExpanded}
          setIsEditing={setIsEditing}
          isCurrentUserReviewer={isCurrentUserReviewer}
        />
      )}
    </div>
  );
};

export default AssignmentContainer;
